import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SharedService } from 'src/Services/shared.service'

@Injectable()
export class XRequestIdInterceptor implements HttpInterceptor {
  constructor(private sharedService: SharedService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const cloned = req.clone({
      setHeaders: {
        'X_REQUEST_ID': this.sharedService.randomString.getValue()
      }
    });
    return next.handle(cloned);
  }
}